import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import ErrorBoundary from './ErrorBoundary.jsx'
import App from './App.jsx'
import AuthProvider from './auth/AuthProvider.jsx'
import { initSentry } from './config/sentry.js'
// Phase 37 Plan 03 — onboarding.css ownership moved here from App.jsx so the
// CSS lifecycle is owned by the entry point rather than a feature component.
import './onboarding.css'
import './ui.css'

initSentry()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
)
